import { connect } from 'react-redux';
import CertifiedAccreditationModal, {AVAILABLE_ACTIONS} from './CertifiedAccreditationModal';
import {
    getCertifiedAccreditationDataById,
    removeCertificateAccreditation
} from '../../../reducers/applicantAccreditations/certifiedAccreditations';
import {
    getActiveModal,
    hideModal,
    MODAL_REMOVE_CERTIFIED_ACCREDITATION
} from '../../../reducers/common/activeModal';
import { resetSubmitFormData } from "../../../reducers/common/submitForm";
import { getTranslation } from "../../../reducers/common/localization";

const mapStateToProps = (state, { id }) => {
    return {
        action: AVAILABLE_ACTIONS.REMOVE,
        isOpen: getActiveModal(state).modalKey === MODAL_REMOVE_CERTIFIED_ACCREDITATION,
        data: getCertifiedAccreditationDataById(state, id),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = (dispatch, { id }) => {
    return {
        onCancel: () => {
            dispatch(hideModal());
            dispatch(resetSubmitFormData());
        },
        onRemove: () => {
            dispatch(removeCertificateAccreditation(id));
            dispatch(resetSubmitFormData());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CertifiedAccreditationModal);



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/certifiedAccreditationModal/RemoveCertifiedAccreditationModal.container.js